import { ChangeDetectionStrategy, Component, inject, input, model, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { I18n, NgtLinkComponent } from '@corporate/ng-tebis-base-components';
import { MatFormFieldModule } from "@angular/material/form-field";
import { AssistantMessageComponent } from '../../../assistant/assistant-message/assistant-message.component';
import { MatChipsModule } from '@angular/material/chips';
import { WindowedRouterLinkComponent } from '../../../../01_core/windowed-router-link/windowed-router-link.component';
import { AIForm } from '../../../../03_model/ai-chat-message.model';

export type TaskCreatedData = {
  taskID: string;
  sentDate: Date;
}

@Component({
  selector: 'tps-task-created',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    AssistantMessageComponent,
    MatChipsModule,
    WindowedRouterLinkComponent,
    NgtLinkComponent,
],
  templateUrl: './task-created-message.component.html',
  styleUrl: './task-created-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskCreatedMessageComponent implements AIForm {

  i18n = inject(I18n);

  data = input.required<TaskCreatedData>();
  update = input.required<(newData: any) => void>();

  constructor() {
    this.i18n.addNamespace('assistant');
  }

  getTaskTabLabel(name: string) {
    return signal(name);
  }
}
